<style scoped lang="less">
*{list-style: none;}
#map{width:100vw;height:100vh}
.search{display: flex; justify-content:space-between;padding: 0 10px; position: absolute;top: 15px;left: 20px;width: 540px;height: 55px;background: rgba(33,55,69,.7);border-radius: 30px;}
.heading{margin-left:20px;color:#fff;display: flex;justify-content: center;flex-direction: column;margin: auto;}
.menu{position: absolute;bottom: 8px; right: 20px; top: 20px; height: 95%;display: flex;flex-direction: column;box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.35);overflow: hidden;border-radius: 7px;background: rgba(33, 55, 69, 0.7);}
.header{width: 280px;height: 70px;padding: 10px; background: rgba(33,185,191,.6);
  .title{text-align: center;font-size: 24px;margin: 10px 0;color: #fff;}
  .methods{display: flex;padding:0;margin: 0px 0px;
    li{margin:5px;border-radius: 50%;width: 55px;height: 55px;line-height: 55px;cursor:pointer;
      i{font-size: 35px;color: #fff;}
    }
  }
}
/deep/.inline-input{display: flex;align-items: center;}
/deep/.el-input__inner{width: 250px;background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;border-radius: 20px;}
.inline-input /deep/.el-input__inner{width: 250px;background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;border-radius: 20px 0px 0px 20px;}
/deep/.el-input__suffix{width: 40px;line-height: 55px;font-size: 20px;cursor: pointer;}
/deep/.esri-ui-bottom-right{right: 356px !important;}
/deep/.esri-component{position: fixed;right: 20px;}
/deep/.ol-zoom, .ol-unselectable{display: none;}
/deep/.el-loading-spinner{font-size: 50px;}
/deep/.search-btn{height: 40px;margin: auto 0px;border-radius: 0px 20px 20px 0px;background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;border-left: none;}
.ol-selectable {width: 400px;height: 400px;}
.ol-popup {background-color: white;-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));padding: 15px;border-radius: 10px;border: 1px solid #cccccc;}
/deep/.el-input__inner {color: #FFF;}
/deep/.el-input {width: 250px;}
/deep/.custom-mouse-position {color: #23fffc;font-size: 10px;position: absolute;bottom: 20px;right: 350px;}
</style>

<template>
  <div>
    <div id="map" class="map" v-loading="loading"  element-loading-spinner="el-icon-loading" @contextmenu.prevent="" @mousedown.right="changeRotation('down',$event)" @mouseup.right="changeRotation('up',$event)">
      <div id="mouse-position"></div>
      <Operation ref="Operachild" @easureMent="onMeasure"></Operation>
      <PropertiesView ref="child"></PropertiesView>
    </div>
    <div class="search">
      <div class="heading">
        <h3 style="margin: 0;letter-spacing: 4px;">矿业信息地图</h3>
        <p style="margin:0">Mining Information Map</p>
      </div>
      <el-input class="inline-input" v-model="state" placeholder="请输入关键字搜索" :trigger-on-focus="false">
        <i class="iconfont icon-type" slot="suffix" @click="searchtype()"></i>
      </el-input>
      <el-button icon="el-icon-search" class="search-btn" @click="search(state)"></el-button>
    </div>
    <div class="menu">
      <div class="header">
        <!-- <div><i class="iconfont icon-more" style="font-size: 26px;font-weight: 700;color: #fff;cursor:pointer;"></i></div> -->
        <ul class="methods">
          <li v-for="(each, index) in listary" :key="index" class="list"><i :class="each.icon" :style="each.style" @click="onSelect(index)"></i></li>
        </ul>
      </div>
      <!--资源导航树 -->
      <LayerManager @changeLayer="changeLayer" v-show="flag" ref="layertree"></LayerManager>
      <!--属性查看 -->
      <Legend ref="attquery" v-show="!flag" @propertiesview="propertiesview" @closerFrame="closerFrame"></Legend>
    </div>
    <!--地图切换 -->
    <Mapbtn :maplayer="Basemap" />
    <!--工具条 -->
    <ToolBar ref="cross" @easureMent="onMeasure" @attributeQuery='attrQuery' @spatialQuery="spatialQuery" @UploadFile="UploadFile" @Buffer='Buffer' @Coordinates="locationPoine" @Mark="setMark" @showCross="spaceAnalysis" @showMark="setTagging" @SetOpacity="SetOpacity"></ToolBar>
    <!--空间分析 -->
    <SpaceAnalysis ref="drawcil" @showEcharts='showEcharts'></SpaceAnalysis>
    <!--设置图层透明度 -->
    <SetTransparent ref="layertrees"></SetTransparent>
    <Database ref="uploads"></Database>
    <!--三维矿山坐标 -->
    <MineShow :Mineinfo='Mineinfo'></MineShow>
    <!--三维矿山模型展示 -->
    <Minemodel></Minemodel>
    <!-- 缓冲区类型选择 -->
    <Buffer ref="buffer" @bufferanalysis='bufferanalysis'></Buffer>
    <!-- 缓冲区分析及结果 -->
    <BufferAnalysis ref="analysis" v-if="bufferanalysisFlag" @showEcharts='showEcharts' :bufferanalysisFlag="bufferanalysisFlag" @closeEcharts='closeEcharts'></BufferAnalysis>
    <!-- echarts图 -->
    <Echarts ref="echarts"></Echarts>
    <!-- 标注 -->
    <Mark ref="mark" @setOperation='setOperation' @getpointAry='getpointAry'></Mark>
    <!-- 搜索类型选择 -->
    <Radio ref="radio"></Radio>
    <!-- 搜索结果展示 -->
    <Search ref="search" @showEcharts='showEcharts' @closeEcharts='closeEcharts'></Search>
    <!-- 坐标查询 -->
    <Coordinates ref="coordinates"></Coordinates>
  </div>
</template>

<script>
import 'ol/ol.css'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import Mapbtn from './Mapbtn'
import LayerManager from './LayerManager'
import ToolBar from './ToolBar'
import Legend from './Legend'
import SpaceAnalysis from './SpaceAnalysis'
import SetTransparent from './SetTransparent'
import Database from './Database'
import Buffer from './Buffer'
import Measure from './Measure'
import MineShow from './MineShow'
import Minemodel from './Minemodel'
import BufferAnalysis from './BufferAnalysis'
import Mark from './Mark'
import Echarts from './Echarts'
import Radio from './Radio'
import Search from './Search'
import Coordinates from './Coordinates'
import Operation from './Operation'
import PropertiesView from './PropertiesView'
import MousePosition from 'ol/control/MousePosition'
import {createStringXY} from 'ol/coordinate'
import {defaults as defaultControls} from 'ol/control'
export default {
  components: {Mapbtn, LayerManager, ToolBar, Legend, SpaceAnalysis, SetTransparent, Database, Buffer, BufferAnalysis, Mark, Echarts, MineShow, Minemodel, Radio, Search, Coordinates, Operation, PropertiesView},
  mixins: [Measure],
  data()
  {
    return {
      Basemap: [],
      loading: false,
      listary:
      [
        {icon: 'iconfont icon-layers', title: '图层管理', name: 'LayerManager'},
        {icon: 'iconfont icon-mulu', title: '图例展示', name: 'Legend'}
      ],
      flag: true,
      state: '',
      Layernar: [],
      Mineinfo: false,
      isdialogVisible: false,
      minemodel: false,
      //缓冲区分析
      bufferanalysisFlag: false,
      //标注
      markFlag: false,
      //选中图层
      checkedNode: [],
      kyqFlag: false,
      kyqFlag2: false

    }
  },
  created()
  {
    //加载菜单
    this.$nextTick(() =>
    {
      this.onSelect(0)
    })
    //搜索事件绑定至键盘回车上
    let lett = this
    document.onkeydown = function(e)
    {
      let key = window.event.keyCode
      if (key === 13)
        lett.search(lett.state)
    }
  },
  mounted()
  {
    this.$nextTick(() =>
    {
      this.loadModules()
      //刷新窗口兼容IE
      setTimeout(() =>
      {
        window.map.updateSize()
      }, 1000)
    })
  },
  methods:
  {
    //选中当前button
    onSelect(index)
    {
      let list = document.querySelectorAll('.list')
      let alltableArray = Array.prototype.slice.call(list)
      alltableArray.forEach(e =>
      {
        e.style.background = 'none'
      })
      list[index].style.background = 'rgba(33,185,191,1)'
      if (index === 0)
        this.flag = true
      else
        this.flag = false
    },
    //加载底图
    loadModules()
    {
      var layer1 = new TileLayer({
        title: '矢量底图',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=vec_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: false
      })
      var layer2 = new TileLayer({
        title: '影像底图',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=img_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: true
      })
      var layer3 = new TileLayer({
        title: '中文注记',
        namee: 'ChineseNotes',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=cva_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: true
      })
      var layer4 = new TileLayer({
        title: '地形底图',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=ter_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: false
      })
      // 实例化鼠标位置控件
      const mousePositionControl = new MousePosition({
        coordinateFormat: createStringXY(9),
        projection: 'EPSG:4326',
        className: 'custom-mouse-position',
        target: 'map'
      })
      let map = new Map({
        target: 'map',
        layers: [layer1, layer2, layer4, layer3],
        overlays: [],
        view: new View({
          center: [108.21, 7.01],
          projection: 'EPSG:4326',
          zoom: 5
        }),
        controls: defaultControls().extend([mousePositionControl])
      })
      window.map = map
      this.Basemap = [{name: '矢量底图', layer: layer1}, {name: '卫星底图', layer: layer2}, {name: '地形底图', layer: layer4}]
    },
    /**
     * 量算
     * @method
     * @param {Object} grp 指定面积量算还是距离量算
     */
    onMeasure(grp)
    {
      this.measure(window.map, grp.title)
      this.$store.commit('onMarktype', grp.title)
      //关闭属性查看功能
      this.$refs.attquery.closeQuery()
      //清除空间分析图形
      this.$refs.drawcil.clearGraphical()
      //清除缓冲区图形
      if (this.bufferanalysisFlag)
      {
        //关闭缓冲区设置弹框
        this.$refs.buffer.closePul(false)
        this.$refs.analysis.clear()
      }
      //清除标注
      this.$refs.mark.clear()
      //关闭标注框
      this.$refs.mark.closePul(false)
      //清除坐标
      this.$refs.coordinates.clear()
      //清除搜索
      this.$refs.search.clear()
      //清除透明度设置弹框
      this.checkedNode = this.$refs.layertrees.closePul(false)
    },
    /**
     * 属性查看
     * @method
     * @param  {Boolean}  flag true false 控制是否查看属性
     */
    attrQuery()
    {
      this.$refs.attquery.attrQuery(this.Layernar)
      //清除量算结果
      this.measure(window.map, 'delete')
      //清除空间分析图形
      this.$refs.drawcil.clearGraphical()
      //清除缓冲区图形
      if (this.bufferanalysisFlag)
      {
        //关闭缓冲区设置弹框
        this.$refs.buffer.closePul(false)
        this.$refs.analysis.clear()
      }
    },
    /**
     * 坐标定位
     */
    locationPoine()
    {
      this.$refs.coordinates.showLP()
      //关闭空间分析工具条
      this.$refs.cross.closeCross(false)
      //关闭标注工具条
      this.$refs.cross.closeMark(false)
    },
    /**
     * 打开标注类型选择
     */
    setTagging()
    {
      //打开标注工具条
      this.$refs.cross.showMark()
      //关闭空间分析工具条
      this.$refs.cross.closeCross(false)
      //关闭坐标定位框
      this.$refs.coordinates.closePul(false)
      //清除空间分析图形
      this.$refs.drawcil.clearGraphical()
      //关闭属性查看功能
      this.$refs.attquery.closeQuery()
      //清除缓冲区图形
      if (this.bufferanalysisFlag)
      {
        //关闭缓冲区设置弹框
        this.$refs.buffer.closePul(false)
        this.$refs.analysis.clear()
      }
    },
    /**
     * 设置点标注
     */
    setMark()
    {
      this.$refs.mark.closePul(true)
      //关闭标注工具条
      this.$refs.cross.closeMark(false)
      this.$store.commit('onMarktype', 'Point')
    },
    /**
     * 空间查询（空间分析和缓冲区分析）
     */
    spaceAnalysis()
    {
      //打开空间分析工具条
      this.$refs.cross.showCross()
      //关闭标注工具条
      this.$refs.cross.closeMark(false)
      //关闭坐标定位框
      this.$refs.coordinates.closePul(false)
      //清除量算结果
      this.measure(window.map, 'delete')
    },
    /**
     * 打开设置缓冲区-条件字段
     */
    Buffer()
    {
      //打开缓冲区分析弹框
      this.$refs.buffer.closePul(true)
      //关闭属性查看功能
      this.$refs.attquery.closeQuery()
      //清除空间分析图形
      this.$refs.drawcil.clearGraphical()
      //清除量算结果
      this.measure(window.map, 'delete')
    },
    /**
     * 空间分析
     * @method
     * @param {Object} ary 绘制信息
     */
    spatialQuery(ary)
    {
      this.$refs.drawcil.drawGraphical(ary.title, this.Layernar)
      //关闭属性查看功能
      this.$refs.attquery.closeQuery()
      //清除量算结果
      this.measure(window.map, 'delete')
      //清除缓冲区图形
      if (this.bufferanalysisFlag)
      {
        //关闭缓冲区设置弹框
        this.$refs.buffer.closePul(false)
        this.$refs.analysis.clear()
      }
    },
    /**
     * 加载图层
     * @methods
     * @param {Object} node 当前节点对象
     * @param {Boolean} checked 是否选中
     */
    changeLayer(obj)
    {
      if (obj.node.namec === '三维矿山')
        this.Mineinfo = obj.checked
      switch (obj.node.name)
      {
      case 'Vietnam Right' : this.kyqFlag = true
        break
      case 'Thailand Right' : this.kyqFlag = true
        break
      case 'Myanmar Right' : this.kyqFlag =  true
        break
      case 'Laos Right' : this.kyqFlag =  true
        break
      case 'Cambodia Right' : this.kyqFlag =  true
        break
      case 'Singapore Right' : this.kyqFlag =  true
        break
      case 'Malaysia Right' : this.kyqFlag =  true
        break
      case 'Indonesia Right' : this.kyqFlag = true
        break
      case 'Brunei Right' : this.kyqFlag = true
        break
      case 'Country MineralDeposit' : this.kyqFlag = true
        break
      case 'Vietnam' : this.kyqFlag =  true
        break
      case 'Vietnam1' : this.kyqFlag =  true
        break
      case 'Thailand' : this.kyqFlag =  true
        break
      case 'Myanmar' : this.kyqFlag =  true
        break
      case 'Laos' : this.kyqFlag =  true
        break
      case 'Cambodia' : this.kyqFlag =  true
        break
      case 'Singapore' : this.kyqFlag = true
        break
      case 'Malaysia' : this.kyqFlag = true
        break
      case 'Indonesia' : this.kyqFlag = true
        break
      case 'Brunei' : this.kyqFlag = true
        break
      case 'Philippines' : this.kyqFlag =  true
        break
      case 'Minerals' : this.kyqFlag =  true
        break
      case 'Coal' : this.kyqFlag =  true
        break
      case 'Iron' : this.kyqFlag =  true
        break
      case 'Aluminum' : this.kyqFlag = true
        break
      case 'Tin' : this.kyqFlag = true
        break
      case 'Chromium' : this.kyqFlag =  true
        break
      case 'Lead' : this.kyqFlag =  true
        break
      case 'Zinc' : this.kyqFlag =  true
        break
      case 'Sylvite' : this.kyqFlag =  true
        break
      case 'Gold' : this.kyqFlag = true
        break
      case 'Nickel' : this.kyqFlag = true
        break
      case 'Copper' : this.kyqFlag = true
        break
      case 'Manganese' : this.kyqFlag = true
        break
      }
      
      // if (this.kyqFlag)
      // {
      //   if (!localStorage.getItem('username'))
      //   {
      //     this.$message(
      //       {
      //         message: '请您登录之后再查看相关数据',
      //         type: 'warning',
      //         customClass: 'mzindex'
      //       }
      //     )
      //     this.kyqFlag = false
      //   }
      //   else
      //     this.getLoadlayer(obj)
      // }
      // else
      if (obj.node.url === '' && obj.checked === true)
        this.$message({message: '暂无数据', type: 'error'})
      else
        this.getLoadlayer(obj)
    },
    //获取加载图层
    getLoadlayer(obj)
    {
      this.$refs.attquery.onChange(obj.node, obj.checked, obj.checkild)
      //获取当前勾选的图层属性信息
      if ((obj.checked && !obj.checkild) && obj.node.maptype)
        this.Layernar.push(obj.node.maptype)
      else if (!obj.checked && !obj.checkild)
      {
        if (this.Layernar.indexOf(obj.node.maptype) !== -1)
        {
          let index = this.Layernar.indexOf(obj.node.maptype)
          this.Layernar.splice(index, 1)
        }
      }
    },
    /**
     * 文件上传
     */
    UploadFile()
    {
      this.$refs.uploads.closePul(true)
    },
    /**
     * 设置图层透明度
     */
    SetOpacity()
    {
      if (this.$store.state.checkNode.length > 0)
        this.checkedNode = this.$refs.layertrees.closePul(true)
      else
        return this.$message({message: '请先勾选图层', type: 'warning', customClass: 'mzindex'})
    },
    /**
     * 缓冲区分析-实例操作以及结果
     * @param {Object} form 缓冲区分析条件对象
     */
    bufferanalysis(form)
    {
      this.bufferanalysisFlag = true
      this.$nextTick(function()
      {
        this.$refs.analysis.bufferanalysis(form, this.Layernar)
      })
    },
    /**
     * 打开echarts
     */
    showEcharts(xAxis, yAxis, series, typeName)
    {
      this.$refs.echarts.show(true, xAxis, yAxis, series, typeName)
    },
    /**
     * 打开搜索类型选择
     */
    searchtype()
    {
      this.$refs.radio.closePul(true)
    },
    /**
     * 调用具体搜索方法
     */
    search(val)
    {
      this.$refs.search.search(val)
    },
    /**
     * 关闭echarts
     */
    closeEcharts()
    {
      this.$refs.echarts.closePul(false)
    },
    setOperation(obj, Layer, evt)
    {
      this.$refs.Operachild.propertiesview(window.map, obj, Layer, evt)
    },
    //属性查看
    propertiesview(pointary, e)
    {
      this.$refs.child.propertiesview(window.map, pointary, e)
    },
    closerFrame()
    {
      this.$refs.child.closerFrame()
    },
    //用户储存的标注转化后的VectorLayer
    getpointAry(obj)
    {
      this.$refs.Operachild.getpointAry(obj)
    },
    // 鼠标右击点击
    changeRotation: function(type, event)
    {
      // console.log(type, event)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Kyyztoply.vue